import { isAlphanumericAllSpecialCharacters,isAlphanumericAllSpecialCharactersAmpersand } from "../../../functions/validations";
import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";

const getRowError = (error, type, isGroove = false) => {
  const fields = isGroove 
    ? ['ProductForm', 'Spec', 'Pno', 'Gno', 'Thk']
    : ['ProductForm', 'Spec', 'Pno', 'Gno', 'Size', 'Sch', 'Thk', 'Dia'];
  const hasError = fields.some(field => error[`PQR_BM_${type}_${field}`]?.status);
  const errorField = fields.find(field => error[`PQR_BM_${type}_${field}`]?.message);
  return {
    hasError,
    errorMessage: errorField ? error[`PQR_BM_${type}_${errorField}`]?.message : ''
  };
};



export const BaseMetalTablePQR = ({
  headerObj,
  error,
  isReadonly,
  isDisabled,
  handleChange,
  setError,
  PNoActive,
  setheaderObj,
  errorstyle,
  blyestyle,
}) => {
 
  const isGroove = headerObj?.wld_WPSType === "Groove";
  
  const baseColumns = [
    { type: 'label', field: "label", width: '150px' },
    { header: 'Product Form', field: 'ProductForm', type: 'input', maxLength: 15, validator: isAlphanumericAllSpecialCharactersAmpersand, className: "WpsInput-md" },
    { header: 'Spec (type of Grade),UNS#', field: 'Spec', type: 'input', maxLength: 25, validator: isAlphanumericAllSpecialCharactersAmpersand, className: "WpsInput-md" },
    { header: 'P No.', field: 'Pno', type: 'select', data: PNoActive, valueField: 'wld_code', labelField: 'wld_code', className: "WPSSelect", customHandler: true },
    { header: 'G No.', field: 'Gno', type: 'input', maxLength: 5, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" },
  ];
  
  const grooveColumns = [
    { header: 'Thk mm', field: 'Thk', type: 'input', maxLength: headerObj?.wld_WPSType === "Tubesheet" ? 6 : 10, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" }
  ];
  
  const nonGrooveColumns = [
    { header: 'Size', field: 'Size', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" },
    { header: 'Sch', field: 'Sch', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" },
    { header: 'Thk mm', field: 'Thk', type: 'input', maxLength: headerObj?.wld_WPSType === "Tubesheet" ? 6 : 10, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" },
    { header: 'Dia mm', field: 'Dia', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters, className: "WpsInput-md" }
  ];
  
  const columns = isGroove 
    ? [...baseColumns, ...grooveColumns]
    : [...baseColumns, ...nonGrooveColumns];

  const createRowData = (type, label) => {
    const baseData = {
      label: { value: label },
      ProductForm: { value: headerObj?.[`PQR_BM_${type}_ProductForm`], field: `PQR_BM_${type}_ProductForm`, error: error[`PQR_BM_${type}_ProductForm`]?.status || false },
      Spec: { value: headerObj?.[`PQR_BM_${type}_Spec`], field: `PQR_BM_${type}_Spec`, error: error[`PQR_BM_${type}_Spec`]?.status || false },
      Pno: {
        value: headerObj?.[`PQR_BM_${type}_Pno`], field: `PQR_BM_${type}_Pno`, error: error[`PQR_BM_${type}_Pno`]?.status || false, customHandler: (value) => {
          setheaderObj((prev) => ({ ...prev, [`PQR_BM_${type}_Pno`]: value }));
          setError((prevState) => ({ ...prevState, [`PQR_BM_${type}_Pno`]: {} }));
        }
      },
      Gno: { value: headerObj?.[`PQR_BM_${type}_Gno`], field: `PQR_BM_${type}_Gno`, error: error[`PQR_BM_${type}_Gno`]?.status || false },
      Thk: { value: headerObj?.[`PQR_BM_${type}_Thk`], field: `PQR_BM_${type}_Thk`, error: error[`PQR_BM_${type}_Thk`]?.status || false },
      ...getRowError(error, type, isGroove)
    };
    
    if (!isGroove) {
      baseData.Size = { value: headerObj?.[`PQR_BM_${type}_Size`], field: `PQR_BM_${type}_Size`, error: error[`PQR_BM_${type}_Size`]?.status || false };
      baseData.Sch = { value: headerObj?.[`PQR_BM_${type}_Sch`], field: `PQR_BM_${type}_Sch`, error: error[`PQR_BM_${type}_Sch`]?.status || false };
      baseData.Dia = { value: headerObj?.[`PQR_BM_${type}_Dia`], field: `PQR_BM_${type}_Dia`, error: error[`PQR_BM_${type}_Dia`]?.status || false };
    }
    
    return baseData;
  };

  const tableData = {
    rows: [
      createRowData("BM", "Base Metal 1"),
      createRowData("WTBM", "Welded To - Base Metal 2")
    ]
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      disableFields={isDisabled}
      dropdownData={{
        Pno: [PNoActive]
      }}
      customColumnStyle={"border thead-color"}
      
    />
  );
};

export const BaseMetalTable_PQRTube = ({
  headerObj,
  error,
  isReadonly,
  isDisabled,
  handleChange,
  setError,
  PNoActive,
  setheaderObj,
  errorstyle,
  blyestyle,
  id,
}) => {
  const columns = [
    { type: 'label', field: "label", width: '150px' },
    {
      header: 'Product Form (Optional)',
      field: 'ProductForm',
      type: 'input',
      maxLength: 15,
      validator:  isAlphanumericAllSpecialCharactersAmpersand,
      className: "WpsInput-md",
      inputWidth: '135px'
    },
    {
      header: 'Spec (type of Grade),UNS (Optional)',
      field: 'Spec',
      type: 'input',
      maxLength: 25,
      validator:  isAlphanumericAllSpecialCharactersAmpersand,
      className: "WpsInput-md",
      inputWidth: '135px'
    },
    {
      header: 'P No. /A No. (Optional)',
      field: 'Pno',
      type: 'select',
      data: PNoActive,
      valueField: 'wld_code',
      labelField: 'wld_code',
      className: "WPSSelect",
      customHandler: true
    },
    {
      header: 'G No. (Optional)',
      field: 'Gno',
      type: 'input',
      maxLength: 5,
      validator: isAlphanumericAllSpecialCharacters,
      className: "WpsInput-md",
      inputWidth: '135px'
    },
    {
      header: 'Thk.mm (Optional)',
      field: 'Thk',
      type: 'input',
      maxLength: 10,
      validator:  isAlphanumericAllSpecialCharactersAmpersand,
      className: "WpsInput-md",
      inputWidth: '135px'
    },
    {
      header: 'Dia.mm (Optional)',
      field: 'Dia',
      type: 'input',
      maxLength: 6,
      validator:  isAlphanumericAllSpecialCharactersAmpersand,
      className: "WpsInput-md",
      inputWidth: '135px'
    }
  ];

  const tableData = {
    rows: [
      {
        label: { value: 'Base Metal 1' },
        ProductForm: { value: headerObj?.PQR_BM_BM_ProductForm, field: "PQR_BM_BM_ProductForm", error: error["PQR_BM_BM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.PQR_BM_BM_Spec, field: "PQR_BM_BM_Spec", error: error["PQR_BM_BM_Spec"]?.status || false },
        Pno: {
          value: headerObj?.PQR_BM_BM_Pno, field: "PQR_BM_BM_Pno", error: error["PQR_BM_BM_Pno"]?.status || false, customHandler: (value) => {
            setheaderObj((prev) => ({ ...prev, PQR_BM_BM_Pno: value }));
            setError((prevState) => ({ ...prevState, PQR_BM_BM_Pno: {} }));
          }
        },
        Gno: { value: headerObj?.PQR_BM_BM_Gno, field: "PQR_BM_BM_Gno", error: error["PQR_BM_BM_Gno"]?.status || false },
        Thk: { value: headerObj?.PQR_BM_BM_Thk, field: "PQR_BM_BM_Thk", error: error["PQR_BM_BM_Thk"]?.status || false },
        Dia: { value: headerObj?.PQR_BM_BM_Dia, field: "PQR_BM_BM_Dia", error: error["PQR_BM_BM_Dia"]?.status || false },
        ...getRowError(error, "BM")
      },
      {
        label: { value: 'Welded To - Base Metal 2' },
        ProductForm: { value: headerObj?.PQR_BM_WTBM_ProductForm, field: "PQR_BM_WTBM_ProductForm", error: error["PQR_BM_WTBM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.PQR_BM_WTBM_Spec, field: "PQR_BM_WTBM_Spec", error: error["PQR_BM_WTBM_Spec"]?.status || false },
        Pno: {
          value: headerObj?.PQR_BM_WTBM_Pno, field: "PQR_BM_WTBM_Pno", error: error["PQR_BM_WTBM_Pno"]?.status || false, customHandler: (value) => {
            setheaderObj((prev) => ({ ...prev, PQR_BM_WTBM_Pno: value }));
            setError((prevState) => ({ ...prevState, PQR_BM_WTBM_Pno: {} }));
          }
        },
        Gno: { value: headerObj?.PQR_BM_WTBM_Gno, field: "PQR_BM_WTBM_Gno", error: error["PQR_BM_WTBM_Gno"]?.status || false },
        Thk: { value: headerObj?.PQR_BM_WTBM_Thk, field: "PQR_BM_WTBM_Thk", error: error["PQR_BM_WTBM_Thk"]?.status || false },
        Dia: { value: headerObj?.PQR_BM_WTBM_Dia, field: "PQR_BM_WTBM_Dia", error: error["PQR_BM_WTBM_Dia"]?.status || false },
        ...getRowError(error, "WTBM")
      }
    ]
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      dropdownData={{
        Pno: [PNoActive]
      }}
      disableFields={isDisabled}
      
      customColumnStyle={"border thead-color"}
    />
  );
};
